exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".category-ddl .gray-light-background .form-check{margin-bottom:10px}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/components/Partials/CustomAddMoreMenuItem.vue"],"names":[],"mappings":"AACA,iDACE,kBAAoB,CACrB","file":"CustomAddMoreMenuItem.vue","sourcesContent":["\n.category-ddl .gray-light-background .form-check{\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-73fbaea7","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/Partials/CustomAddMoreMenuItem.vue
// module id = 1941
// module chunks = 0